export default __webpack_public_path__ + "static/media/miguel-lopes-22.6aad7e9b.jpg";